import axios from '../utils/request'

const login = (loginInfo) => {
  return axios.post('Token', {
    ...loginInfo
  })
}

const Changepassword = (loginInfo) => {
  return axios.post('Changepassword', {
    ...loginInfo
  })
}

export {
  login,
  Changepassword
}
